import React from 'react'
import Bocconi from '../assets/images/bocconi-logo.jpg'
import PoliMi from '../assets/images/PoliMi.png'
import Cattolica from '../assets/images/cattolica-logo.png'
import Rufa from '../assets/images/logo-rufa.png'
import Unicat from '../assets/images/unicat.png'
import Ied from '../assets/images/ied-logo.jpg'
import Csc from '../assets/images/csc-logo.png'
import Azimut from '../assets/images/azimut.png'

const PaymentLogo = () => {
  return (
    <div className="w-full overflow-auto flex items-center lg:flex-wrap lg:overflow-hidden">
      <img src={PoliMi} className="w-3/12 object-contain" style={{ maxHeight: '64px' }} />
      <img src={Cattolica} className="w-3/12 object-contain" style={{ maxHeight: '64px' }} />
      <img src={Azimut} className="w-3/12 object-contain" style={{ maxHeight: '64px' }} />
    </div>
  )
}

export default PaymentLogo
